@if (platformModeService.isNativeApp()) {
  <ion-content [fullscreen]="true" class="bw-auth-shell__native">
    <div class="bw-auth-shell__viewport">
      <router-outlet></router-outlet>
    </div>
  </ion-content>
} @else {
  <main class="bw-auth-shell">
    <router-outlet></router-outlet>
  </main>
}

